import api from "../config/api"


export const getAllDistances = async () => {
    const response = await api.get('/distance/');
    return response.data;
}

export const getDistanceById = async (id) => {
    const response = await api.get(`/distance/?id=${id}`);
    return response.data;
}

export const getDistanceSourceAndDestination = async(sourceId, destinationId) => {
    const response = await api.get(`/distance/?source_id=${sourceId}&destination_id=${destinationId}`);
    return response.data;

}

export const saveDistancesBulk = async (data) => {
  const response = await api.post("/distance/bulk/", data, {
    headers: { "Content-Type": "application/json" },
  });
  return response.data;
};



export const deleteDistance = async(id) => {
    const response = await api.delete(`/distance/?id=${id}`);
    return response.data;
}